import React from "react";
import { SectionHeader } from "../components/section-header.tsx";
import { FontStyles } from "../utils/font-styles.ts";
import { cn } from "../utils/cn.ts";
import { TextLink } from "../components/text-link.tsx";
import { type LinkItem, usePropertyDetailsContext } from "./contexts/property-details-context.tsx";
import type { PropertyDetailsContextValue } from "./contexts/property-details-context.tsx";

export function hasLinks(ctx: PropertyDetailsContextValue): boolean {
  return (ctx.soldNearbyLinks?.length ?? 0) > 0 || (ctx.usefulLinks?.length ?? 0) > 0;
}

const LinkColumn: React.FC<{ title: string; links: LinkItem[] }> = ({ title, links }) => {
  if (!links.length) return null;

  return (
    <nav className="flex flex-col flex-1 gap-3 md:gap-3.5 min-w-0" aria-label={title}>
      <SectionHeader text={title} as="h2" className={FontStyles.h5} />
      {links.map((link) => (
        <React.Fragment key={`${link.href}-${link.label}`}>
          <hr aria-hidden="true" className="outline outline-1 outline-cloud border-0" />
          <div className="flex">
            <TextLink className={cn(FontStyles["body-md"], "inline-block max-w-full truncate")} href={link.href}>
              {link.label}
            </TextLink>
          </div>
        </React.Fragment>
      ))}
    </nav>
  );
};

export const LinksTable: React.FC = () => {
  const ctx = usePropertyDetailsContext();
  const { usefulLinks = [], soldNearbyLinks = [] } = ctx;

  if (!hasLinks(ctx)) return null;

  return (
    <div className="flex flex-col md:flex-row gap-7.5 lg:gap-8 w-full min-w-0">
      <LinkColumn title="Properties sold nearby" links={soldNearbyLinks} />
      <LinkColumn title="Useful Links" links={usefulLinks} />
    </div>
  );
};
